import ErrorRoundedIcon from "@mui/icons-material/ErrorRounded";
import { Box } from "@mui/system";
import type { JSX } from "react";

import { NotificationPanel } from "@/components/notificationPanel/NotificationPanel";

interface NotEnoughDataNotificationBoxProps {
  show: boolean;
  header: string;
  text: string;
}

export const NotEnoughDataNotificationBox = ({
  show,
  header,
  text,
}: NotEnoughDataNotificationBoxProps): JSX.Element | null => {
  if (!show) return null;
  return (
    <Box sx={{ alignContent: "center", padding: "0 20px 10px 20px" }}>
      <NotificationPanel
        type="error"
        icon={
          <ErrorRoundedIcon
            sx={{
              color: "#9F0037",
              fontSize: 30,
              alignSelf: "center",
            }}
          />
        }
        header={header}
        text={text}
      />
    </Box>
  );
};
